<template>
  <div class="base">
    <div @click="handleClick" style="cursor: pointer">
      <span class="blue-color">
        {{ dailyRates.length }}晚
        <svg-icon v-if="isClick" icon-class="dobuleArrowUp"></svg-icon>
        <svg-icon v-else icon-class="dobuleArrowDown"></svg-icon>
      </span>
      <span class="span-right"> ￥{{ calPrice(dailyRates) }} </span>
    </div>
    <div v-if="isClick">
      <div v-for="(item, i) in dailyRates" :key="i">
        <span>{{ item.date }}</span
        ><span class="span-right">￥{{ item.value }}</span>
      </div>
    </div>
    <!-- <div>
      <span class="blue-color">每晚税费</span>
      <span class="span-right">￥1104.80</span>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    dailyRates: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      isClick: true
    }
  },
  methods: {
    handleClick () {
      this.isClick = !this.isClick
    },
    calPrice (dailyRates) {
      let count = 0
      if (dailyRates.length) {
        for (let i = 0; i < dailyRates.length; i++) {
          count += Number(dailyRates[i].value)
        }
      }
      return count
    }
  }
}
</script>

<style lang="stylus" scoped>
.base {
  font-size: 14px;
  padding: 10px 20px 10px 30px;
  line-height: 25px;
  font-weight: 500;
}

.span-right {
  float: right;
}

.blue-color {
  color: #144199;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/FoldPanel.vue